import { render, staticRenderFns } from "./VagnTable.vue?vue&type=template&id=e3fa5148&"
import script from "./VagnTable.vue?vue&type=script&lang=js&"
export * from "./VagnTable.vue?vue&type=script&lang=js&"
import style0 from "./VagnTable.vue?vue&type=style&index=0&id=e3fa5148&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports